import React, {
    forwardRef,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import styles from "./styles/Footer.module.css";
import MediaCard from "./MediaCard";
import DataContext from "../../context/DataContext";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import useRefDimensions from "../../hooks/useRefDimensions";
import useMaxHeightOfChildren from "../../hooks/useMaxHeightOfChildren";

/**
 * Footer root component
 */
const Footer = () => {
    const { t, ready } = useTranslation();
    const location = useLocation();
    const [isMessageAvailable, setIsMessageAvailable] = useState(false);

    // Ref of the cards component that is used in the
    // useMaxHeightOfChildren hook to determine if the item is mounted
    const cardContainerRef = useRef();

    const {
        currentCustom, // {Object} - The object containing the client customization
        isServiceDataAvailable, // {Boolean} - Indicates if the service data is available
        islocalizationsAvailable, // {Boolean} - Indicates if the localizations are available
        isRedirecting, // {Boolean} - Indicates if a redirection is in progress
        setPaymentHeaderFooterHeight, // {Function} - Function to set the height of the calculated header and footer in the payment module
        FOOTER_OFFSET, // {Integer} - The offset value for the footer that is used in the calculation (the padding, margin, etc...)
    } = useContext(DataContext);

    // Get the height of the footer and header using custom hook
    const footerHeaderHeight = useMaxHeightOfChildren(
        "footerCardsContainer",
        FOOTER_OFFSET,
        cardContainerRef,
    );

    // Set the height of the payment header and footer
    useEffect(() => {
        setPaymentHeaderFooterHeight(footerHeaderHeight);
    }, [footerHeaderHeight]);

    useEffect(() => {
        if (!ready) return;
        const hasMessage =
            currentCustom?.footer?.cards?.some(
                (card) => t(card.message)?.trim() !== "",
            ) ?? false;

        setIsMessageAvailable(hasMessage);
    }, [currentCustom?.footer, ready, t]);

    const currentYear = new Date().getFullYear();

    const POSCopyright = (
        <span className={`${styles.footer_copyright_POS}`}>
            &copy; {`${currentYear} PanStreet International GmbH`}
        </span>
    );
    // const POSCopyright = (
    //     <>
    //         <span className={`${styles.copyright_powered}`}>powered by</span>{" "}
    //         <span
    //             className={`${styles.copyright_panstreet}`}
    //         >{` PanStreet ${currentYear}`}</span>
    //     </>
    // );

    return (
        !isRedirecting &&
        isServiceDataAvailable &&
        islocalizationsAvailable && (
            <footer className={`${styles.footer_container}  v-flex-container`}>
                <h2 className={`${styles.footer_header} flex-container`}>
                    {/* {t(currentCustom?.footer?.header)} */}
                    {!location.pathname.includes("/pos")
                        ? t(currentCustom?.footer?.header)
                        : POSCopyright}
                </h2>

                {!location.pathname.includes("customization") &&
                !location.pathname.includes("/pos") ? (
                    <>
                        <ul
                            ref={cardContainerRef}
                            id="footerCardsContainer"
                            className={`${styles.media_cards_container} main-container flex-container`}
                        >
                            {currentCustom?.footer?.cards
                                ?.filter((card) => card?.enable)
                                .map((card) => (
                                    <li
                                        className={`${styles.media_card_item} flex-container`}
                                        key={card?.id}
                                    >
                                        <MediaCard
                                            cardInfo={card}
                                            isMessageAvailable={
                                                isMessageAvailable
                                            }
                                        />
                                    </li>
                                ))}
                        </ul>
                        <p className={`${styles.footer_copyright}`}>
                            &copy;{" "}
                            {`${currentYear} PanStreet International GmbH`}
                        </p>
                        {/* <p className={`${styles.footer_copyright}`}>
                            <span className={`${styles.copyright_powered}`}>
                                {`powered by`}
                            </span>
                            {`PanStreet ${currentYear}`}
                        </p> */}
                    </>
                ) : (
                    <></>
                )}
            </footer>
        )
    );
};

export default Footer;
